import { languageDisplayNames } from "../constants";

export const getSandboxLanguages = (
  availableLanguages: string[]
): { label: string; value: string }[] => {
  return availableLanguages
    .map(lang => ({
      label: getLanguageLabel(lang),
      value: lang,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const getLanguageLabel = (languageKey: string): string => {
  return languageDisplayNames[languageKey] || languageKey;
};

// for mapping languages in exercise metadata to Monaco editor options
// all languages match as-is besides dotnet
const MonacoLanguageMap: { [key: string]: string } = {
  dotnet: "csharp",
};

export const getMonacoLanguage = (languageKey: string): string => {
  return MonacoLanguageMap[languageKey] || languageKey;
};
